import { useState } from 'react';
import { api, setSession } from '../api/client.ts';
import { NOM_APPLICATION } from '../config/affichage.ts';
import { chargerPermissions, oublierPermissions } from '../config/permissions.ts';

export default function Login({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: React.FormEvent) {
    e.preventDefault();
    setErreur(null);
    setEnCours(true);
    try {
      const { token, role, csbId, nomCompte, doitChangerMdp, profil } = await api.post<{ token: string; role: string; csbId: string | null; nomCompte?: string; doitChangerMdp?: boolean; profil?: string | null }>(
        '/auth/login',
        { email, password }
      );
      oublierPermissions(); // droits d'un éventuel ancien compte (session expirée) : jamais réutilisés pour ce compte
      setSession(token, role, csbId, nomCompte ?? '');
      localStorage.setItem('prerma_profil', profil ?? '');
      if (doitChangerMdp) localStorage.setItem('prerma_mdp_a_changer', '1'); else { localStorage.removeItem('prerma_mdp_a_changer'); await chargerPermissions(); }
      onLoggedIn();
    } catch (err: any) {
      setErreur(err.message ?? 'Connexion impossible');
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="app-content">
      <img src="/icons/icon-192.png" alt="Logo" width={96} height={96} style={{ display: 'block', margin: '0 auto 12px', borderRadius: 20 }} />
      <h1>{NOM_APPLICATION}</h1>
      <p>Outil pratique d'aide au comptage, à la consolidation et au suivi des données.</p>
      <form onSubmit={soumettre}>
        <label htmlFor="email">Identifiant / e-mail</label>
        <input id="email" type="email" autoCapitalize="none" autoCorrect="off" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
        <label htmlFor="password">Mot de passe</label>
        <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        {erreur && <p className="messages-erreur">{erreur}</p>}
        <div style={{ marginTop: 20 }}>
          <button type="submit" disabled={enCours}>{enCours ? 'Connexion…' : 'Se connecter'}</button>
        </div>
      </form>
      <p style={{ marginTop: 40, fontSize: '0.85rem', color: '#666' }}>
        Conception — ANDRIANANTOAVINA S.E.      </p>
    </div>
  );
}
